import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Transport} from '../../model/Entities/Transport';

@Component({
    selector: 'complete-transport-cancel-confirm-dialog',
    templateUrl: './complete-transport-cancel-confirm.dialog.component.html',
})
export class CompleteTransportCancelConfirmDialogComponent {

    transport: Transport;

    constructor(public dialog: MatDialogRef<CompleteTransportCancelConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.transport = data.transport;
    }
}




// WEBPACK FOOTER //
// /app/src/TransportModule/CompleteTransportCancelConfirmDialogComponent/complete-transport-cancel-confirm.dialog.component.ts